import { ProductListWUT } from '@wix/form-fields/viewer-wut';

export default ProductListWUT;
